import { Card } from 'antd'

interface PageSkeletonProps {
  mainCol?: string
  sidebarCol?: string
}

const PageSkeleton = ({ mainCol = 'col-9', sidebarCol = 'col-3' }: PageSkeletonProps) => (
  <div className="d-flex flex-column gap-3" aria-busy="true" aria-label="Loading page">
    <Card loading />
    <div className="row g-3">
      <div className={mainCol}>
        <Card loading />
      </div>
      <div className={sidebarCol}>
        <Card loading />
      </div>
    </div>
    <Card loading />
  </div>
)

export default PageSkeleton
